import React from "react";
import { connect } from "react-redux";
import FormElement from "components/FormElement";
import { setValue } from "actions/request";
import { requestFields } from "helpers/BatterySupplierHelper";
import { toggleOptions } from "helpers/SupplierHelper";

class ModelOptions extends React.Component {
  requestField = requestFields.modelOption;

  componentWillUnmount() {
    this.props.setValue(this.requestField, "");
  }

  render() {
    const { request } = this.props;

    // do not render untill supplier be selected:
    if (!request[requestFields.supplier]) return null;

    return (
      <FormElement
        type="toggleRadioGroup"
        id={this.requestField}
        label="Cell Model"
        value={request[this.requestField]}
        list={toggleOptions}
      />
    );
  }
}

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps, { setValue })(ModelOptions);
